import { render, staticRenderFns } from "./unit-q-ans-list.html?vue&type=template&id=6cdefcb3&scoped=true&"
import script from "./unit-q-ans-list.js?vue&type=script&lang=js&"
export * from "./unit-q-ans-list.js?vue&type=script&lang=js&"
import style0 from "./unit-q-ans-list.scss?vue&type=style&index=0&id=6cdefcb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdefcb3",
  null
  
)

export default component.exports